import styled from 'astroturf/react';

const svg = styled('div')`
  position: relative;
  display: inline-block;

  svg {
    max-width: 100%;
    max-height: 100%;
  }

  &.gray path {
    fill: var(--ph-gray-500);
  }

  rect {
    stroke-width: 3px;
  }
`;

export default { Svg: svg };
